import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

/**
 * @return {null}
 */

const Container = styled.div`
	display: flex;
	flex-direction: column;
`

const Header = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 24px;
`

const Content = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
`

const Slot = styled.div`
	display: block;
	min-width: 0;
`

function TableHeaderComponent(props) {
	const { left, right, children } = props
	if (!left || !right) {
		return null
	}
	return (
		<Container>
			<Header>
				{left && <Slot>{left}</Slot>}
				{right && <Slot>{right}</Slot>}
			</Header>
			<Content>
				{children}
			</Content>
		</Container>
	)
}

// eslint-disable-next-line import/prefer-default-export
export const TableHeader = TableHeaderComponent

TableHeader.defaultProps = {}

TableHeader.propTypes = {
	left: PropTypes.node,
	right: PropTypes.node,
	children: PropTypes.node
}
